module.exports = __webpack_public_path__ + "img/login_logo.dacb328e.png";